import { isEmpty } from 'lodash'
import React, { useState } from 'react'
import { useForm, useFormState } from 'react-final-form'
import { Form } from 'semantic-ui-react'
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse, Method } from 'axios'
import { toast } from 'react-toastify'

import { RemoveProductModal } from '../RemoveProductModal'
import { API_PRODUCTS } from '../../../consts'
import { to } from '../../../utils/to'
import { useImageList } from '@iheartjane/react-image-list'

const RemovalButton = ({
  removalStatus,
  disabled,
  onClick,
}: {
  removalStatus?: string | null
  disabled: boolean
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}) => {
  switch (removalStatus) {
    case null:
      return (
        <Form.Button color="red" disabled={disabled} onClick={onClick} type="button">
          Remove
        </Form.Button>
      )
    case 'pending':
      return (
        <Form.Button color="yellow" disabled={disabled} onClick={onClick} type="button">
          Cancel Removal
        </Form.Button>
      )
    default:
      return <></>
  }
}

export const EditActions = () => {
  const { submitting, pristine, errors, values } = useFormState()
  const { reset } = useForm()
  const hasErrors = !isEmpty(errors)
  const { resetImages } = useImageList()

  const [removeSubmitting, setRemoveSubmitting] = useState(false)
  const [removeConfirmation, setRemoveConfirmation] = useState(false)

  const handleReset = () => {
    const userConfirm = window.confirm(
      'Any unsaved changes will be lost. Would you like to proceed?'
    )
    if (userConfirm) {
      reset()
      resetImages()
    }
  }

  const handleRemove = async () => {
    const productId = values.id
    let method: Method = 'POST'
    let successMessage = `Product #${productId} removal initiated, the request will be processed shortly.`
    let errorMessage = `Error: failed to initiate removal for product #${productId}`

    if (values.removal_status === 'pending') {
      method = 'DELETE'
      successMessage = `Product #${productId} removal cancellation sent, will be processed shortly.`
      errorMessage = `Error: failed to cancel removal for product #${productId}`
    }

    setRemoveSubmitting(true)

    const axiosRequestObj: AxiosRequestConfig = {
      url: `${API_PRODUCTS}/${productId}/removal`,
      method: method,
      withCredentials: true,
    }

    const [error] = await to<AxiosResponse, AxiosError>(axios(axiosRequestObj))

    if (error) {
      toast(errorMessage, {
        containerId: 'error',
      })
    } else {
      toast(successMessage, {
        containerId: 'default',
      })
    }
  }

  const removalButtonOnClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    setRemoveConfirmation(true)
  }

  return (
    <>
      <RemovalButton
        removalStatus={values.removal_status}
        disabled={submitting || removeSubmitting}
        onClick={removalButtonOnClickHandler}
      />
      <Form.Button disabled={submitting || pristine} onClick={handleReset} type="button">
        Reset
      </Form.Button>
      <Form.Button primary disabled={submitting || hasErrors || pristine} type="submit">
        Save
      </Form.Button>

      <RemoveProductModal
        open={removeConfirmation}
        setOpen={setRemoveConfirmation}
        onConfirm={handleRemove}
        removalStatus={values.removal_status}
        productId={values.id}
      />
    </>
  )
}
